
<v-autocomplete
    v-model="selected"
    :items="suggestions"
    :loading="loading"
    :search-input.sync="search"
    item-text="formatted_name"
    item-value="place_id"
    :label="value || 'Search for a city'"
    placeholder="Enter a city name"
    clearable
    @input="handleInput"
    @clear="handleInput"
    @keydown.enter="handleSearchInput"
    return-object
    outlined
    dense
    append-icon="mdi-chevron-down"
    :error-messages="errorMessages"
>
    <template v-slot:item="{ item }">
        <v-list-item-content>
            <v-list-item-title>{{ item.formatted_name }}</v-list-item-title>
        </v-list-item-content>
    </template>
    <template v-slot:selection="{ item }">
        <span>{{ item ? item.formatted_name : '' }}</span>
    </template>
    <template v-slot:no-data>
        <v-list-item>
            <v-list-item-title>No cities found</v-list-item-title>
        </v-list-item>
    </template>
</v-autocomplete>
